"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const UserContext_1 = require("context/UserContext");
const HelperUtils_1 = require("utils/HelperUtils");
const Dropdown_1 = __importStar(require("components/design-system/dropdown/Dropdown"));
const Trigger_1 = __importDefault(require("components/design-system/dropdown/Trigger"));
const FloatingComponent_1 = __importDefault(require("components/objectives/compact-objective/fragments/FloatingComponent"));
const ConditionalWrapper_1 = __importDefault(require("components/shared/ConditionalWrapper"));
function DropdownType({ handleChange, defaultValue = null, objectiveCategories = [], customTrigger, dropdownPosition = 'right', rightIcon, dropdownTriggerClass = 'w-[190px]', dropdownMenuItemsClass = 'w-[240px]', disabled = false, useFloating = false }) {
    const { config: { mandatoryObjectivesCategory } } = (0, UserContext_1.useUser)();
    const [selectedValue, setSelectedValue] = (0, react_1.useState)({
        text: 'No type selected',
        colorHex: ''
    });
    const handleClickDropdown = (value) => {
        setSelectedValue({ text: value?.name, colorHex: value?.colorHex || '000' });
        handleChange(value);
    };
    const getMappingColor = (color) => {
        const mapColor = (0, HelperUtils_1.mappingColor)(color, 'tw');
        return mapColor?.twBg;
    };
    (0, react_1.useEffect)(() => {
        if (defaultValue !== null && objectiveCategories?.length > 0) {
            const defaultCategory = objectiveCategories?.find(({ id }) => id === defaultValue);
            setSelectedValue({
                text: defaultCategory?.name,
                colorHex: defaultCategory?.colorHex
            });
        }
        else {
            setSelectedValue({ text: 'No type selected', colorHex: '000' });
        }
    }, [defaultValue, objectiveCategories]);
    return (react_1.default.createElement(Dropdown_1.default, { customClass: "w-full" },
        react_1.default.createElement(Dropdown_1.default.Trigger, { dataCy: "dropdown-type", disabled: disabled }, customTrigger ? (customTrigger) : (react_1.default.createElement(Trigger_1.default, { icon: "", topLabel: false, label: "", text: selectedValue.text, textStyle: { color: `#${selectedValue?.colorHex}` }, customWrapperClass: dropdownTriggerClass, iconName: rightIcon, disabled: disabled }))),
        react_1.default.createElement(DropdownItems, { dropdownMenuItemsClass: dropdownMenuItemsClass, dropdownPosition: dropdownPosition, mandatoryObjectivesCategory: mandatoryObjectivesCategory, objectiveCategories: objectiveCategories, handleClickDropdown: handleClickDropdown, getMappingColor: getMappingColor, useFloating: useFloating })));
}
const DropdownItems = ({ dropdownMenuItemsClass, dropdownPosition, mandatoryObjectivesCategory, objectiveCategories, handleClickDropdown, getMappingColor, useFloating }) => {
    const { open } = (0, Dropdown_1.useDropdown)() || {};
    return (react_1.default.createElement(react_1.default.Fragment, null, open && (react_1.default.createElement(ConditionalWrapper_1.default, { condition: useFloating, wrapper: (children) => (react_1.default.createElement(FloatingComponent_1.default, { lockScroll: false }, children)) },
        react_1.default.createElement(Dropdown_1.default.MenuItems, { type: useFloating ? 'absolute' : 'fixed', customClass: dropdownMenuItemsClass, position: dropdownPosition, maxHeight: 186 },
            !mandatoryObjectivesCategory && (react_1.default.createElement(Dropdown_1.default.MenuItem, { divider: true, onClick: () => handleClickDropdown({ id: null, name: 'No type selected' }) }, "No Type")),
            objectiveCategories?.map((objectiveCategory, index) => (react_1.default.createElement(Dropdown_1.default.MenuItem, { key: index, onClick: () => handleClickDropdown(objectiveCategory), dataCy: `dropdown-type-option-${objectiveCategory?.id}` },
                react_1.default.createElement("div", { className: "flex items-center w-full" },
                    react_1.default.createElement("div", { className: (0, classnames_template_literals_1.default)(`w-[20px] h-[20px] mr-[8px] rounded-full ${getMappingColor(objectiveCategory?.colorHex)}`) }),
                    react_1.default.createElement("span", { className: "truncate w-[180px]" }, objectiveCategory?.name))))))))));
};
exports.default = DropdownType;
